<template>
    <iframe
        v-if="!isNil(sessionToken)"
        ref="iframe"
        width="100%"
        height="220"
        scrolling="no"
        style="border: 0"
        :src="cardCaptureUrl"
    >
    </iframe>
</template>



<script>
import isNil from 'lodash/isNil';
import API from '../../../api';
import { nonBlockingPoll } from '../../../utils/non-blocking-poll';
import { GATEWAY_CHANNEX_SESSION_ENDPOINT } from '../../../endpoints';

const PCI_PROXY_DOMAIN = 'https://pci.channex.io';

export default {
    props: {
        autoValidate: {
            type: Boolean,
            default: false,
        },
        validPaymentCardTypes: {
            type: Array,
            default: null,
        },
    },
    computed: {
        cardCaptureUrl() {
            return `https://pci.channex.io/api/v1/capture_form?session_token=${this.sessionToken}${this.cardTypes}`;
        },
        cardTypes() {
            return this.validPaymentCardTypes
                ? '&only=' + this.validPaymentCardTypes.map((c) => c.name.split(' ').join('-').toLowerCase()).join()
                : '';
        },
    },
    data() {
        return {
            sessionToken: null,
        };
    },
    methods: {
        isNil,
        async fetchSessionToken() {
            try {
                const { data } = await API.get(GATEWAY_CHANNEX_SESSION_ENDPOINT());
                this.sessionToken = data;
            } catch (err) {
                this.errorToast({ text: 'Could not load session token.' });
            }
        },
        handleMessage(event) {
            if (event.origin !== PCI_PROXY_DOMAIN) {
                return;
            }

            if (event.data.success) {
                this.sessionToken = null;
                this.$emit('success-tokenize-card', event.data.card);
                return;
            }

            if (event.data.valid !== undefined) {
                if (event.data.valid) {
                    this.$emit('validate-callback', 'OK');
                } else {
                    this.$emit('validate-callback', 'INVALID');
                }
            }
        },
        submit() {
            return this.$refs.iframe.contentWindow.postMessage('submit', PCI_PROXY_DOMAIN);
        },
        validate() {
            return this.$refs.iframe.contentWindow.postMessage('validate', PCI_PROXY_DOMAIN);
        },
    },
    mounted() {
        window.addEventListener('message', this.handleMessage);
        this.fetchSessionToken();
        if (this.autoValidate) {
            nonBlockingPoll(
                () =>
                    new Promise(() => {
                        if (this.$refs.iframe) {
                            this.validate();
                        }
                    }),
                500
            );
        }
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleMessage);
    },
};
</script>

<style lang="sass" scoped>
:deep(.field__error-message) {
    font-size: 41px !important;
    font-weight: bold;
}
</style>

